import hotToast from 'react-hot-toast';

import { Toast, ToastKind } from '@blockworks/ui/components';

type OptionsType = {
    title?: string;
    duration?: number;
};

const displayToast = (kind: ToastKind, message: React.ReactNode, opts?: OptionsType) =>
    hotToast.custom(
        t => <Toast title={opts?.title} description={message} kind={kind} onClose={() => hotToast.dismiss(t.id)} />,
        {
            duration: opts?.duration ?? 12000, // 12s
        },
    );

/** A simple utility to trigger toasts with a single function call */
const toast = {
    success: (message: React.ReactNode, opts?: OptionsType) => {
        const { title = 'Success!' } = opts ?? {};
        return displayToast(ToastKind.Success, message, { title, ...opts });
    },
    danger: (message: React.ReactNode, opts?: OptionsType) => {
        const { title = 'Error' } = opts ?? {};
        return displayToast(ToastKind.Danger, message, { title, ...opts });
    },
    warning: (message: React.ReactNode, opts?: OptionsType) => {
        return displayToast(ToastKind.Warning, message, opts);
    },
    info: (message: React.ReactNode, opts?: OptionsType) => {
        return displayToast(ToastKind.Info, message, opts);
    },
};

export { toast };
